import { render, staticRenderFns } from "./PopupAwards.vue?vue&type=template&id=1f9c51b4"
import script from "./PopupAwards.vue?vue&type=script&lang=js"
export * from "./PopupAwards.vue?vue&type=script&lang=js"
import style0 from "./PopupAwards.vue?vue&type=style&index=0&id=1f9c51b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports